import { render } from "./BookingDaysAdd.vue?vue&type=template&id=783b315d&scoped=true"
import script from "./BookingDaysAdd.vue?vue&type=script&lang=js"
export * from "./BookingDaysAdd.vue?vue&type=script&lang=js"

import "./BookingDaysAdd.vue?vue&type=style&index=0&id=783b315d&scoped=true&lang=css"

import exportComponent from "/var/www/boa/bo/frontend/boa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-783b315d"]])

export default __exports__